import { createAction, props } from '@ngrx/store';

export enum NewClientEnquiryActionTypes {
  Init = '[NewClientEnquiry Page] Initialised',
  FormSubmitted = '[NewClientEnquiry Page] Form Submitted',
}

export const NewClientEnquiryActions = {
  init: createAction(NewClientEnquiryActionTypes.Init),
  formSubmitted: createAction(
    NewClientEnquiryActionTypes.FormSubmitted,
    props<{
      selectedProducts: number[];
    }>()
  ),
};
